import React, { Suspense } from 'react';
import gql from 'graphql-tag';
import { ApolloProvider, useQuery } from '@apollo/client';
import ReactDOM from 'react-dom';
import CatalogPartnerCard from './CatalogPartnerCard';
import { renderCatalogPartnerModal } from './CatalogPartnerModalLoader';
export const QUERY = gql `
  query CatalogPartnerCardLoaderQuery($documentId: String) {
    viewer {
      userId
      user {
        mailAddress
      }
      cloudPartnerCatalog(documentId: $documentId) {
        documentId
        available
        status
      }
    }
  }
`;
export const CatalogPartnerCardLoader = (props) => {
    const { documentId } = props;
    const { loading, error, data } = useQuery(QUERY, {
        variables: {
            documentId,
        },
    });
    if (loading)
        return React.createElement(React.Fragment, null);
    if (error)
        return React.createElement("div", null, error.message);
    if (data && data.viewer && data.viewer.cloudPartnerCatalog) {
        const available = data.viewer.cloudPartnerCatalog.available;
        const status = data.viewer.cloudPartnerCatalog.status;
        if (data.viewer && [0, 7].includes(status)) {
            return React.createElement(CatalogPartnerCard, { documentId: documentId, available: available, status: status });
        }
    }
    return React.createElement(React.Fragment, null);
};
CatalogPartnerCardLoader.displayName = 'CatalogPartnerCardLoader';
export default CatalogPartnerCardLoader;
export const renderCatalogPartnerCard = (apolloClient) => {
    const partnerLinkCard = document.getElementById('partner-link-card');
    if (partnerLinkCard && partnerLinkCard.dataset.document_id) {
        // Load Card
        ReactDOM.render(React.createElement(ApolloProvider, { client: apolloClient },
            React.createElement(Suspense, { fallback: React.createElement("div", null) },
                React.createElement(CatalogPartnerCardLoader, { documentId: partnerLinkCard.dataset.document_id }))), partnerLinkCard);
        renderCatalogPartnerModal();
    }
};
